/* eslint-disable no-unused-vars */
/* eslint-disable no-sparse-arrays */
export const AssetTypes = [
  { label: "LAPTOP", value: "laptop" },
  { label: "MONITOR", value: "monitor" },
  { label: "PC", value: "pc" },
  {
    label: "PHONE",
    value: "phone",
  },
  {
    label: "SIM",
    value: "sim",
  },

  {
    label: "OTHER",
    value: "Other",
  },
];

export const AssetStatus = [
  {
    label: "ALLOCATED",
    value: "Allocated",
  },
  {
    label: "RETURNED",
    value: "Returned",
  },
];

export const batchOptions = [
  {
    label: "Batch1",
    value: "batch1",
  },
  {
    label: "Batch2",
    value: "batch2",
  },
];

export const recruiterWise = {
  JOINED: "Joined",
  NOTJOINED: "Not Joined",
};
export const BoardSort = [
  { label: "Title", value: "title" },
  { label: "Start Date", value: "startDate" },
  { label: "End Date", value: "endDate" },
  { label: "Assigned To", value: "assignedTo" },
];

export const ProspectType = [
  {
    label: "Client",
    value: "client",
  },
  {
    label: "VENDOR",
    value: "vendor",
  },
];

export const Status = [
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Inactive",
    value: "inactive",
  },
];
export const Gsttypes = [
  {
    label: "CGST",
    value: "cGST",
  },
  {
    label: "IGST",
    value: "iGST",
  },
  {
    label: "SGST",
    value: "sGST",
  },
];

export const Gst = [
  {
    label: "5%",
    value: "5",
  },
  {
    label: "12%",
    value: "12",
  },
  {
    label: "18%",
    value: "18",
  },
  {
    label: "22%",
    value: "22",
  },
  {
    label: "28%",
    value: "28",
  },
];

export const endpoints = {
  GRAPHQL: `${import.meta.env.VITE_APP_SERVER_URL}/api/v1/graphql`,
  STORAGE_URL: `${import.meta.env.STORAGE_URL}`,
};

export const jobFilterLatest = [
  { label: "All", value: "All" },
  { label: "Job Id", value: "JobId" },
  { label: "Job Title", value: "jobTitle" },
  { label: "Latest", value: "Latest" },
];

export const jobFilterPriority = [
  { label: "All", value: "All" },
  { label: "Hot", value: "Hot" },
  { label: "High", value: "High" },
  { label: "Medium", value: "Medium" },
  { label: "Low", value: "Low" },
];

export const JobTypes = [
  { label: "CONTRACT", value: "Contract" },
  { label: "CONTRACT HIRE", value: "Contract Hire" },
  { label: "PERMANENT", value: "Permanent" },
];

export const EmploymentType = [
  { label: "FULL TIME", value: "Full Time" },
  { label: "PART TIME", value: "Part Time" },
  { label: "CONTRACT", value: "Contract" },
];

export const JobPriceType = [
  { label: "DOLLAR/USD", value: "Dollar/USD" },
  { label: "GBP/BRITISH POUND", value: "GBP/British pound" },
  { label: "INR", value: "INR" },
];

export const regReasonOpt = [
  { label: "Resignation", value: "Resignation" },
  { label: "Reteriment", value: "Reteriment" },
  { label: "Termination", value: "Termination" },
];

export const JobPriority = [
  { label: "HOT", value: "Hot" },
  { label: "HIGH", value: "High" },
  { label: "MEDIUM", value: "Medium" },
  { label: "LOW", value: "Low" },
];

export const JobNoticePeriod = [
  { label: "Immediate", value: "Immediate" },
  { label: "0-15 DAYS", value: "0-15 days" },
  { label: "15-30days", value: "15-30 days" },
  { label: "30-45 DAYS", value: "30-45 days" },
  { label: "45-60 DAYS", value: "45-60 days" },
  { label: "60-75 DAYS", value: "60-75 days" },
  { label: "75-90 DAYS", value: "75-90 days" },
];

export const JobStatus = [
  { label: "ACTIVE", value: "active" },
  { label: "IN ACTIVE", value: "inActive" },
  { label: "CLOSED", value: "closed" },
];

export const JobWorkType = [
  { label: "WORK FROM HOME", value: "Work from Home" },
  { label: "WORK FROM OFFICE", value: "Work from Office" },
  { label: "HYBRID", value: "Hybrid" },
];

export const EmployeeTypes = [
  { label: "CONTRACT", value: "Contract" },
  { label: "CONTRACT HIRE", value: "Contract Hire" },
  { label: "PERMANENT", value: "Permanent" },
];

export const RevenueTypes = [
  { label: "ONE TIME", value: "One Time" },
  { label: "RECURRING", value: "Recurring" },
];
export const StatusType = [
  { label: "ACTIVE", value: "Active" },
  { label: "IN ACTIVE", value: "InActive" },
];
export const LeaveTypes = [
  { label: "CASUAL LEAVE(CL)", value: "Casual Leave" },
  { label: "SICK LEAVE(SL)", value: "Sick Leave" },
  { label: "EARNED LEAVE(EL)", value: "Earned Leave" },
  { label: "COMPENSATORY LEAVE", value: "Compensatory Leave" },
  { label: "PATERNITY LEAVE", value: "Paternity Leave" },
  { label: "MATERNITY LEAVE", value: "Maternity Leave" },
  { label: "LOP", value: "lop" },
];

export const InterviewLevels = [
  { label: "HR", value: "HR" },
  { label: "L1", value: "L1" },
  { label: "L2", value: "L2" },
  { label: "MANAGER", value: "Manager" },
];

export const ModeOfInterview = [
  { label: "OFFLINE", value: "Offline" },
  { label: "TELEPHONIC", value: "Telephonic" },
  { label: "VIDEOCALL", value: "VideoCall" },
];
export const Gender = [
  { label: "MALE", value: "Male" },
  { label: "FEMALE", value: "Female" },
  { label: "TRANSGENDER", value: "Transgender" },
  { label: "NON-BINARY", value: "Non-binary/Non-conforming" },
  { label: "PREFER NOT TO ANSWER", value: "Prefer not to respond" },
  { label: "OTHERS", value: "Others" },
];

export const PayrollPeriod = [
  {
    label: "15th-14th",
    value: "15th-14th",
  },
  {
    label: "24th-23rd",
    value: "24th-23rd",
  },
];

export const ApplicantColumns = [
  {
    field: "applicantId",
    headerName: "Applicant Id",
    width: 130,
    // renderCell: (params) => (
    //   <div
    //     style={{ cursor: "pointer" }}
    //     onClick={() => handleCellClick(params)}
    //   >
    //     {params.value}
    //   </div>
    // ),
  },
  { field: "firstName", headerName: "Applicant Name", width: 150 },
  {
    field: "totalWorkExp",
    headerName: "Experience (Years)",
    width: 150,
  },
  {
    field: "location",
    headerName: "Location",
    width: 150,
    renderCell: (params) => {
      return <p>{params?.row?.employment[0]?.currentLocation}</p>;
    },
  },
  {
    field: "expectedCtc",
    headerName: "Expected CTC",
    renderCell: (params) => {
      return <p>{params?.row?.employment[0]?.expectedCtc}</p>;
    },
    width: 120,
  },
  {
    field: "skills",
    headerName: "Skills",
    width: 300,
    renderCell: (params) => {
      const skills = params?.row?.employment[0]?.skills || [];
      return (
        <div
          style={{
            maxHeight: "60px",
            overflowY: "auto",
            whiteSpace: "normal",
            wordBreak: "break-word",
            padding: "10px",
          }}
        >
          {skills.join(", ")}
        </div>
      );
    },
  },
  {
    field: "match_percentage",
    headerName: "Matched Percentage",
    width: 200,
    renderCell: (params) => {
      return (
        <p>
          {params?.row?.match_percentage !== undefined &&
            params?.row?.match_percentage !== null &&
            params?.row?.match_percentage !== ""
            ? params?.row?.match_percentage + " %"
            : ""}
        </p>
      );
    },
  },
];

export const CourseColumns = [
  {
    field: "studentApplicantId",
    headerName: "Student Applicant Id",
    width: 170,
    // renderCell: (params) => (
    //   <div
    //     style={{ cursor: "pointer" }}
    //     onClick={() => handleCellClick(params)}
    //   >
    //     {params.value}
    //   </div>
    // ),
  },
  { field: "firstName", headerName: "Applicant Name", width: 170 },
  {
    field: "lastName",
    headerName: "Last Name",
    width: 170,
  },
  {
    field: "email",
    headerName: "Email",
    width: 190,
  },
  {
    field: "phone",
    headerName: "Mobile Number",
    width: 170,
  },
];

export const applicantmapclickable = [
  {
    col: "applicantId",
    // link: "/ApplicantSpecificDetails",
    link: "/applicant/view/specific",
    // params: true,
  },
];

export const NoticePeriods = [
  { label: "Immediate", value: "Immediate" },
  { label: "0-15 DAYS", value: "0-15 days" },
  { label: "15-30days", value: "15-30 days" },
  { label: "30-45 DAYS", value: "30-45 days" },
  { label: "45-60 DAYS", value: "45-60 days" },
  { label: "60-75 DAYS", value: "60-75 days" },
  { label: "75-90 DAYS", value: "75-90 days" },
];

export const HoldingOffer = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
];
export const UserRelation = [
  { label: "FATHER", value: "Father" },
  { label: "MOTHER", value: "Mother" },
  { label: "BROTHER", value: "Brother" },
  { label: "SISTER", value: "Sister" },
  { label: "SPOUSE", value: "Spouse" },
  { label: "CHILDREN", value: "Children" },
];

export const BloodGroup = [
  { label: "A+", value: "A+" },
  { label: "A-", value: "A-" },
  { label: "B+", value: "B+" },
  { label: "B-", value: "B-" },
  { label: "O+", value: "O+" },
  { label: "O-", value: "O-" },
  { label: "AB+", value: "AB+" },
  { label: "AB-", value: "AB-" },
];

export const SelectinterviewData = [
  { label: "SCREENING SELECT", value: "Screening Select" },
  { label: "SCREENING REJECT", value: "Screening Reject" },
  { label: "L1 SELECT", value: "L1 select" },
  { label: "L1 HOLD", value: "L1 hold" },
  { label: "L1 REJECT", value: "L1 reject" },
  { label: "L2 SELECT", value: "L2 select" },
  { label: "L2 HOLD", value: "L2 hold" },
  { label: "L2 REJECT", value: "L2 reject" },
  { label: "HR SELECT", value: "HR select" },
  { label: "HR HOLD", value: "HR hold" },
  { label: "HR REJECT", value: "HR reject" },
  { label: "OFFER ACCEPTED", value: "Offer accepted" },
  { label: "OFFER ROLLOUT", value: "Offer rollout" },
  { label: "NOT JOIN", value: "Notjoin" },
  { label: "FINALLY JOIN", value: "Finallyjoin" },
];

// export const interviewStatus = [
//   { data: ["", "Screening reject"], step: 0 },
//   { data: ["Screening select", "L1 reject"], step: 1 },
//   { data: ["L1 select", "L2 reject"], step: 2 },
//   { data: ["L2 select", "HR reject"], step: 3 },
//   { data: ["HR select", "Offer rolled out"], step: 4 },
//   { data: ["Offer accepted", "Offer join"], step: 5 },
//   { data: ["Finally join"], step: 6 },
// ];

export const interviewStatus = [
  { data: ["", "Screening reject"], step: 0 },
  { data: ["Screening Select", "L1 reject", "L1 hold"], step: 1 },
  { data: ["L1 select", "L2 reject", "L2 hold"], step: 2 },
  { data: ["L2 select", "HR reject", "HR hold"], step: 3 },
  { data: ["HR select", "Offer rollout"], step: 4 },
  { data: ["Offer accepted", "Offer join"], step: 5 },
  { data: ["Finallyjoin", "Notjoin", ""], step: 6 },
];

export const SortByData = [
  { label: "Client", value: "clientDetails.name" },
  { label: "RECRUITER", value: "recruiterDetails.firstName" },
  { label: "JOINING DATE", value: "joiningDate" },
];
export const AllByData = [
  { label: "All", value: "All" },
  { label: "PERMANENT", value: "Permanent" },
  { label: "CONTRACT", value: "Contract" },
];
export const ClaimReasonData = [
  { label: "TRAVEL", value: "Travel" },
  { label: "OTHERS", value: "Others" },
];

export const TypeOfTravel = [
  { label: "Local", value: "Local" },
  { label: "Intercity", value: "Intercity" },
  { label: "International", value: "International" },
];

export const vehicleOptions = [
  { label: "Two Wheeler", value: "twoWheeler" },
  { label: "Four Wheeler", value: "fourWheeler" },
];

export const SalaryAdvanceMonths = [
  { label: "1 month", value: 1 },
  { label: "2 months", value: 2 },
  { label: "3 months", value: 3 },
  { label: "4 months", value: 4 },
  { label: "5 months", value: 5 },
  { label: "6 months", value: 6 },
  { label: "7 months", value: 7 },
  { label: "8 months", value: 8 },
  { label: "9 months", value: 9 },
  { label: "10 months", value: 10 },
  { label: "11 months", value: 11 },
  { label: "12 months", value: 12 },
];
export const courseDurationMonths = [
  { label: "0 month", value: "0" },
  { label: "1 month", value: 1 },
  { label: "2 months", value: 2 },
  { label: "3 months", value: 3 },
  { label: "4 months", value: 4 },
  { label: "5 months", value: 5 },
  { label: "6 months", value: 6 },
  { label: "7 months", value: 7 },
  { label: "8 months", value: 8 },
  { label: "9 months", value: 9 },
  { label: "10 months", value: 10 },
  { label: "11 months", value: 11 },
  { label: "12 months", value: 12 },
];
export const courseDurationYears = [
  { label: "0 year", value: "0" },
  { label: "1 year", value: 1 },
  { label: "2 years", value: 2 },
  { label: "3 years", value: 3 },
  { label: "4 years", value: 4 },
  { label: "5 years", value: 5 },
  { label: "6 years", value: 6 },
  { label: "7 years", value: 7 },
  { label: "8 years", value: 8 },
  { label: "9 years", value: 9 },
  { label: "10 years", value: 10 },
  { label: "11 years", value: 11 },
  { label: "12 years", value: 12 },
];

export const feeTypesOptions = [
  { label: "Semester", value: "semester" },
  { label: "Trimester", value: "trimester" },
  { label: "Year", value: "year" },
];

export const MedicalClaimReasonData = [
  { label: "MEDICAL", value: "Medical" },
  { label: "OTHERS", value: "Others" },
];

export const JoinedstatusData = [
  { label: "JOINED", value: "Joined" },
  { label: "NOT JOINED", value: "Not Joined" },
];
export const HolidayCols = [
  {
    name: "Date",
    col: "date",
  },
  {
    name: "Events",
    col: "event",
  },
];
export const CsvHolidayCols = [
  {
    name: "Country",
    col: "country",
  },
  {
    name: "State",
    col: "state",
  },
  {
    name: "Date",
    col: "date",
  },
  {
    name: "Events",
    col: "event",
  },
];

export const CsvApplicantsCols = [
  {
    name: "FirstName",
    col: "firstName",
  },
  {
    name: "LastName",
    col: "lastName",
  },
  {
    name: "Gender",
    col: "gender",
  },
  {
    name: "Email",
    col: "email",
  },
  {
    name: "Phone",
    col: "phone",
  },
  {
    name: "JobId",
    col: "jobId",
  },
  {
    name: "RecuriterId",
    col: "recruiterId",
  },
  {
    name: "Status",
    col: "status",
  },
];

export const CsvCompensationCols = [
  {
    name: "Employee ID",
    col: "employeeId",
  },
  {
    name: "First Name",
    col: "firstName",
  },
  {
    name: "Last Name",
    col: "lastName",
  },
  {
    name: "Organization ID",
    col: "orgId",
  },
  {
    name: "Effective Date",
    col: "effectiveDate",
  },
  {
    name: "Effective Period",
    col: "effectivePeriod",
  },
  {
    name: "CTC",
    col: "ctc",
  },
  {
    name: "Variable Pay",
    col: "variablePay",
  },
  {
    name: "Salary Template ID",
    col: "salaryTemplateId",
  },
];

export const BoardWorkspace = [
  {
    label: "PRIVATE",
    value: "private",
  },
  {
    label: "PUBLIC",
    value: "public",
  },
];
export const OrderData = [
  {
    label: "ASCENDING",
    value: "ascending",
  },
  {
    label: "DESCENDING",
    value: "descending",
  },
];
export const HolidayData = [
  {
    date: "26-01-2023",
    events: "Republic Day",
  },
  {
    date: "08-03-2023",
    events: "Holi (Optional)",
  },
  {
    date: "22-03-2023",
    events: "Ugadi",
  },
  {
    date: "30-03-2023",
    events: "Srirama Navami",
  },
  {
    date: "07-04-2023",
    events: "Good Friday (Optional)",
  },
  {
    date: "02-06-2023",
    events: "Telangana Formation day",
  },
  {
    date: "15-08-2023",
    events: "Independence day",
  },
  {
    date: "30-08-2023",
    events: "Raksha Bandhan (Optional)",
  },
  {
    date: "19-09-2023",
    events: "Vinayaka Chaturthi",
  },
  {
    date: "02-10-2023",
    events: "Gandhi Jayanti",
  },
  {
    date: "24-10-2023",
    events: "Dussehra / Vijaya Dashami",
  },
  {
    date: "13-11-2023",
    events: "Diwali",
  },
  {
    date: "25-12-2023",
    events: "Christmas",
  },
];
export const status = [
  { label: "All", value: "All" },
  {
    label: "JOINED",
    value: "Joined",
  },
  { label: "NOT JOINED", value: "Not Joined" },
];

export const freePeriodoption = [
  { label: "15 days", value: "15 days" },
  { label: "30 days", value: "30 days" },
  { label: "45 days", value: "45 days" },
  { label: "60 days", value: "60 days" },
  { label: "75 days", value: "75 days" },
  { label: "90 days", value: "90 days" },
];

export const HierarchyTypes = [
  { label: "L1", value: "L1" },
  { label: "L2", value: "L2" },
  { label: "L3", value: "L3" },
  { label: "L4", value: "L4" },
  { label: "L5", value: "L5" },
  { label: "L6", value: "L6" },
  { label: "L7", value: "L7" },
];

export const NotificationType = [
  {
    label: "Announcement Notifications",
    value: "announcement notifications",
  },
  {
    label: "Birthday Notifications",
    value: "birthday notifications",
  },

  {
    label: "Manual Web Push Notifications",
    value: "manual web push notifications",
  },
  {
    label: "Promotional Notifications",
    value: "promotional notifications",
  },
  {
    label: "Reminder Notifications",
    value: "reminder notifications",
  },
  {
    label: "Welcome Notification",
    value: "welcome notification",
  },
];
export const SendNotificationTo = [
  {
    label: "Admin",
    value: "admin",
  },
  {
    label: "Everyone",
    value: "everyone",
  },
];
export const NotificationVisibilitys = [
  {
    label: "Portal level",
    value: "portal level",
  },
  {
    label: "Org level",
    value: "org level",
  },
];
export const NotificationVisibilityfbasedonorg = [
  {
    label: "Org level",
    value: "org level",
  },
];
export const section80d = [
  { label: "Medical Insurance", value: "medical insurance" },
  { label: "Preventive Health check-up", value: "preventive health check-up" },
];
export const taxsections = [
  { label: "Life insurance Premium", value: "life insurance premium" },
  { label: "Provident fund", value: "provident fund" },
  {
    label: "Subscription to certain equity shares",
    value: "subscription to certain equity shares",
  },
  { label: "Tuition Fees", value: "tuition fees" },
  {
    label: "National Savings Certificate",
    value: "national savings certificate",
  },
  { label: "Housing Loan Principal", value: "housing loan principal" },
  { label: "Other various items", value: "other various items" },
  {
    label: "Annuity plan of LIC or other insurer towards Pension Scheme",
    value: "annuity plan of LIC or other insurer towards pension scheme",
  },
  {
    label: "Pension Scheme of Central Government",
    value: "pension scheme of central government",
  },
];
export const othertaxsections = [
  {
    label: "80CCD(1B)-Investments in NPS",
    value: "80CCD(1B)-investments in nps",
  },
  {
    label:
      "80DD-Medical Treatment & Maintenance of a Dependent with Disability",
    value:
      "80DD-medical treatment & maintenance of a dependent with disability",
  },
  {
    label:
      "80DDB-Medical Treatment of Self or Dependent for Specified Diseases  ",
    value:
      "80DDB-medical treatment of self or dependent for specified diseases  ",
  },
  {
    label: "80E-Interest on Education Loan",
    value: "80E-interest on education loan",
  },
  {
    label: "80EE-Interest on home loan for first time home owners",
    value: "80EE-interest on home loan for first time home owners",
  },
  {
    label: "80EEB-Interest on Electric loan vehicles",
    value: "80EEB-interest on electric loan vehicles",
  },
  {
    label: "80EEA-Interest on home loan",
    value: "80EEA-interest on home loan",
  },
  {
    label: "80G-Donation for Social Causes",
    value: "80G-donation for social causes",
  },
  {
    label: "80GGC-Contribution by Individuals to Political Parties",
    value: "80GGC-contribution by individuals to political parties",
  },
  {
    label: "80RRB-Deductions on Income by way of Royalty of Patent",
    value: "80RRB-deductions on income by way of royalty of patent",
  },
  {
    label: "80TTA-Interest on Savings",
    value: "80TTA-interest on Savings",
  },
];
export const subtaxcomponentsof80D = [
  { label: "Self&Family(Below 60 years)", value: "self and family" },
  {
    label: "Self&Family+Parents(All of them below 60 years)",
    value: "self family and parents",
  },
  {
    label: "Self&Family(below 60 years) + Parents(above 60 years)",
    value: "self family/parents",
  },
  {
    label: "Self&Family+Parents(above 60 years)",
    value: "self family/parents above age",
  },
];
export const preventivesubcomponent = [
  { label: "Self&Family(Below 60 years)", value: "self and family" },
  {
    label: "Self&Family+Parents(All of them below 60 years)",
    value: "self family and parents",
  },
];
export const taxcomponentsof80DD = [
  {
    label: "Medical Treatment & maintenance of a dependent with Disability",
    value: "medical treatment & maintenance of a dependent with disability",
  },
  {
    label:
      "Medical Treatment & maintenance of a dependent with Severe Disability",
    value:
      "medical treatment & maintenance of a dependent with severe disability",
  },
];
export const taxcomponentsof80u = [
  {
    label: "Self-Suffering from Disability",
    value: "self-suffering from disability",
  },
  {
    label: "Self-Suffering from Severe Disability",
    value: "self-suffering from severe disability",
  },
];

export const otherincome = [
  { label: "Loss from house property", value: "loss from house property" },
  { label: "Income from other sources", value: "income from other sources" },
  {
    label:
      "Interest earned from Co-Operative Socity, Post Office Savings & SB A/C(exceeding Rs.10,000/-)",
    value:
      "interest earned from Co-operative socity, post office savings & SB A/C(exceeding Rs.10,000/-)",
  },
  {
    label: "Interest/Dividend on FDRs/RDs/Bonds etc",
    value: "interest/Dividend on FDRs/RDs/Bonds etc",
  },
];
export const citydropdown = [
  {
    label: "Metro City",
    value: "metro-city",
  },
  {
    label: "Non-Metro City",
    value: "nonmetro-city",
  },
];

export const STORAGE_URL = "https://temple-dev-191026.storage.googleapis.com";

export const paymentOptions = [
  {
    label: "Due",
    value: "due",
  },
  {
    label: "Paid",
    value: "paid",
  },
  {
    label: "To be paid",
    value: "ToBePaid",
  },
];

export const accountOptions = [
  {
    label: "Purchase",
    value: "purchase",
  },
  {
    label: "Sale",
    value: "sale",
  },
];

export const roundOffOptions = [
  {
    label: "Never Mind",
    value: "Never Mind",
  },
  {
    label: "Nearest Whole Number",
    value: "Nearest Whole Number",
  },
  {
    label: "0.99",
    value: "0.99",
  },
  {
    label: "0.50",
    value: "0.50",
  },
  {
    label: "0.49",
    value: "0.49",
  },
];

export const payrollSteps = ["Earnings", "Review", "Success"];

export const runPayrollheadCells = [
  {
    id: "empname",
    numeric: false,
    disablePadding: true,
    label: "Employee name",
  },

  {
    id: "fixedPay",
    numeric: true,
    disablePadding: false,
    label: "Fixed Pay",
  },
  {
    id: "basicSalary",
    numeric: true,
    disablePadding: false,
    label: "Basic Salary",
  },
  {
    id: "hra",
    numeric: true,
    disablePadding: false,
    label: "HRA",
  },
  {
    id: "ltaAllowance",
    numeric: true,
    disablePadding: false,
    label: "LTA Allowance",
  },
  {
    id: "employerPF",
    numeric: true,
    disablePadding: false,
    label: "Employer PF",
  },
  {
    id: "otherAllowance",
    numeric: true,
    disablePadding: false,
    label: "Other Allowance",
  },
  {
    id: "professionalTax",
    numeric: true,
    disablePadding: false,
    label: "Professional Tax",
  },
  {
    id: "medicalInsurance",
    numeric: true,
    disablePadding: false,
    label: "Medical Insurance",
  },
  {
    id: "pf",
    numeric: true,
    disablePadding: false,
    label: "PF",
  },
  {
    id: "tds",
    numeric: true,
    disablePadding: false,
    label: "TDS",
  },
  {
    id: "lop",
    numeric: true,
    disablePadding: false,
    label: "LOP Days",
  },

  {
    id: "grossSalary",
    numeric: true,
    disablePadding: false,
    label: "Gross Salary",
  },

  {
    id: "totalDeduction",
    numeric: true,
    disablePadding: false,
    label: "Total Deduction",
  },

  {
    id: "variablePay",
    numeric: true,
    disablePadding: false,
    label: "Variable Pay",
  },
  {
    id: "arrears",
    numeric: true,
    disablePadding: false,
    label: "Arrears",
  },
  {
    id: "reimbursement",
    numeric: true,
    disablePadding: false,
    label: "Reimbursement",
  },
  {
    id: "netPayable",
    numeric: true,
    disablePadding: false,
    label: "Net Salary",
  },
  {
    id: "payslippreview",
    numeric: true,
    disablePadding: false,
    label: "Payslip preview",
  },
];

export const currencies = [
  {
    value: "USD",
    label: "US Dollar",
  },
  {
    value: "INR",
    label: " Indian Rupee",
  },
  {
    value: "ZAR",
    label: "South African rand",
  },
];

export const OfferLetterOptions = [
  { label: "Create Experience Letter", value: "Experience Letter" },
  { label: "Create Hike Letter", value: "Hike Letter" },
  { label: "Create Offer Letter", value: "Create Offer Letter" },
  { label: "Create Membership Agreement", value: "Membership Agreement" },
];

export const ViewOfferLetterOptions = [
  { label: "View Experience Letter", value: "ViewExperienceLetter" },
  { label: "View Hike Letter", value: "ViewHikeLetter" },
  { label: "View Offer Letter", value: "ViewOfferLetter" },
  { label: "View Membership Agreement", value: "MembershipAgreement" },
];

export const ApprovalStatus = [
  { label: "Approved", value: "Approved" },
  { label: "Not-Approved", value: "Not-Approved" },
];

export const LeavePeriod = [
  {
    label: "Jan-Dec",
    value: "Jan-Dec",
  },
  {
    label: "Mar-Feb",
    value: "Mar-Feb",
  },
];

export const AssetCreated = [
  {
    label: "Organisation",
    value: "Organisation",
  },
  {
    label: "Client",
    value: "Client",
  },
];

export const securityyQuestions = [
  {
    label: "What is your mother's maiden name?",
    value: "What is your mother's maiden name?",
  },
  {
    label: "In what city were you born?",
    value: "In what city were you born?",
  },
  {
    label: "What is the name of your first pet?",
    value: "What is the name of your first pet?",
  },
  {
    label: "What is your favorite movie?",
    value: "What is your favorite movie?",
  },
  {
    label: "What is the name of your elementary school?",
    value: "What is the name of your elementary school?",
  },
  {
    label: "What is your favorite color?",
    value: "What is your favorite color?",
  },
  {
    label: "What is your favorite book?",
    value: "What is your favorite book?",
  },
  {
    label: "What is your favorite food?",
    value: "What is your favorite food?",
  },
  {
    label: "What is the make and model of your first car?",
    value: "What is the make and model of your first car?",
  },
  {
    label: "What is the name of your best friend in childhood?",
    value: "What is the name of your best friend in childhood?",
  },
  {
    label: "In what year did you graduate from high school?",
    value: "In what year did you graduate from high school?",
  },
  {
    label: "What is your father's middle name?",
    value: "What is your father's middle name?",
  },
  {
    label: "What is the name of the street you grew up on?",
    value: "What is the name of the street you grew up on?",
  },
  {
    label: "What was your favorite subject in school?",
    value: "What was your favorite subject in school?",
  },
  {
    label: "Who is your favorite teacher in school?",
    value: "Who is your favorite teacher in school?",
  },
];

export const workTypes = [
  {
    label: "Work from office",
    value: "Work from office",
  },
  {
    label: "Work from home",
    value: "Work from home",
  },
  {
    label: "onJob",
    value: "onJob",
  },
  {
    label: "Work from client",
    value: "Work from client",
  },
];
export const questionTypes = [
  { label: "Radio", value: "radio" },
  { label: "Checkbox", value: "checkbox" },
  { label: "text", value: "text" },
  {
    label: "File Upload (jpg, jpeg, png, svg, pdf, doc, docx, xls, xlsx, csv)",
    value: "file",
    answer: "",
  },
];
export const payfrequency = [
  {
    label: "Hourly",
    value: "hourly",
  },
  {
    label: "Weekly",
    value: "weekly",
  },
  {
    label: "Monthly",
    value: "monthly",
  },
  {
    label: "Half Yearly",
    value: "halfyearly",
  },
  {
    label: " Yearly",
    value: "yearly",
  },
];
export const inputTypeOptions = [
  {
    label: "Value",
    value: "value",
  },
  {
    label: "Percentage",
    value: "percentage",
  },
];
export const calculationmode = [
  {
    label: "Net Paid Days",
    value: "netpaiddays",
  },
];

export const payrollDeductionOptions = [
  { label: "EmployerPF", value: "employerPF" },
  { label: "Professional Tax", value: "professionalTax" },
  { label: "Medical Insurance", value: "medicalInsurance" },
  { label: "PF", value: "pf" },
  { label: "NPS", value: "nps" },
  { label: "Voluntary PF", value: "voluntaryPF" },
  { label: "Employer ESI", value: "employerESI" },
  { label: "Employee ESI", value: "employeeESI" },
];
export const payrollDeductionParentOptions = [
  { label: "BasicSalary", value: "basicSalary" },
  { label: "Gross Salary", value: "grossSalary" },
];

export const payrollEarningMapOptions = [
  { label: "VariablePay", value: "variablePay" },
  // { label: "Fixed Pay", value: "fixedPay" },
  { label: "BasicSalary", value: "basicSalary" },
  { label: "HRA", value: "hra" },
  { label: "LTA", value: "ltaAllowance" },
  { label: "Other Allowance", value: "otherAllowance" },
];
export const payrollEarningParentOptions = [
  { label: "Fixed Pay", value: "fixedPay" },
  { label: "VariablePay", value: "variablePay" },
  { label: "BasicSalary", value: "basicSalary" },
  { label: "HRA", value: "hra" },
  { label: "LTA", value: "ltaAllowance" },
  { label: "Other Allowance", value: "otherAllowance" },
];

export const EmployeeColumns = [
  {
    field: "userId",
    headerName: "Employee Id",
    width: 150,
  },
  {
    field: "firstName",
    headerName: "First Name",
    width: 150,
  },
  {
    field: "lastName",
    headerName: "Lastame",
    width: 150,
  },
];

export const LeavePeriondOptions = [
  { value: "January", label: "January" },
  { value: "February", label: "February" },
  { value: "March", label: "March" },
  { value: "April", label: "April" },
  { value: "May", label: "May" },
  { value: "June", label: "June" },
  { value: "July", label: "July" },
  { value: "August", label: "August" },
  { value: "September", label: "September" },
  { value: "October", label: "October" },
  { value: "November", label: "November" },
  { value: "December", label: "December" },
];

export const LeavesWorkingDays = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
];

export const Operator = [
  { value: "+", label: "+" },
  { value: "-", label: "-" },
  { value: "*", label: "*" },
  { value: "/", label: "/" },
  { value: "=", label: "=" },
];

export const payrollCycleOptions = [
  { label: "Weekly", value: "weekly" },
  { label: "Monthly", value: "monthly" },
];
export const HierachyOptions = [
  { value: "L1", label: "L1" },
  { value: "L2", label: "L2" },
  { value: "L3", label: "L3" },
];

export const SecondLevelOptions = [
  { value: "Department", label: "Department" },
  { value: "ProjectName", label: "ProjectName" },
  { value: "OrgLevel", label: "OrgLevel" },
];

export const templatePositionOptions = [
  {
    label: "Left",
    value: "left",
  },
  {
    label: "Center",
    value: "center",
  },
  {
    label: "Right",
    value: "right",
  },
];

export const sigatureImagePositionOptions = [
  {
    label: "Above",
    value: "above",
  },
  {
    label: "Below",
    value: "below",
  },
];

export const PayrollCutoffDays = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10" },
  { value: "11", label: "11" },
  { value: "12", label: "12" },
  { value: "13", label: "13" },
  { value: "14", label: "14" },
  { value: "15", label: "15" },
  { value: "16", label: "16" },
  { value: "17", label: "17" },
  { value: "18", label: "18" },
  { value: "19", label: "19" },
  { value: "20", label: "20" },
  { value: "21", label: "21" },
  { value: "22", label: "22" },
  { value: "23", label: "23" },
  { value: "24", label: "24" },
  { value: "25", label: "25" },
  { value: "26", label: "26" },
  { value: "27", label: "27" },
  { value: "28", label: "28" },
  { value: "29", label: "29" },
  { value: "30", label: "30" },
];
export const requiredService = [
  { label: "ATS", value: "ats" },
  { label: "Employee Management", value: "employee_management" },
  { label: "Performance Management", value: "performance_management " },
  { label: "Assets Management", value: "assets_management" },
  { label: "Project Management", value: "project_management" },
  { label: "Billing", value: "billing" },
  { label: "Prospects", value: "prospects" },
  { label: "Reports", value: "reports" },
];

export const erpTypeOptions = [
  { label: "Education", value: "education" },
  { label: "Hospital", value: "hospital" },
  { label: "Industry", value: "industry" },
  { label: "Information Technology", value: "IT" },
  { label: "Retail", value: "retail" },
  { label: "Real Estate", value: "realestate" },
  { label: "Waste Management", value: "wastemanagement" },
];

export const documentVerifyStatus = [
  { label: "To Be Verified", value: "To Be Verified" },
  { label: "Verified", value: "Verified" },
  { label: "Hold", value: "Hold" },
];
export const interactionHistory = [
  { label: "Meeting Notes", value: "meeting notes" },
  { label: "Calls", value: "calls" },
  { label: "Emails", value: "emails" },
];

export const leadStatus = [
  { label: "Closed Not Converted", value: "closed not converted" },
  { label: "Customer", value: "customer" },
  { label: "Meeting Set", value: "meeting set" },
  { label: "New Lead", value: "new lead" },
  { label: "Opportunity Lost", value: "opportunity lost" },
  { label: "Qualified", value: "qualified" },
  { label: "Unqualified", value: "unqualified" },
  { label: "Working Contact", value: "working contact" },
];

export const leadSource = [
  { label: "Cold Call", value: "cold call" },
  { label: "Database", value: "database" },
  { label: "LinkedIn", value: "linkedIn" },
  { label: "Referral", value: "referral" },
  { label: "Social Media", value: "social media" },
  { label: "Website", value: "website" },
];

export const socialMedia = [
  { label: "Youtube", value: "youtube" },
  { label: "Facebook", value: "facebook" },
  { label: "Instagram", value: "instagram" },
  { label: "X", value: "x" },
];

export const priorityLevel = [
  { label: "Cold Leads", value: "cold leads" },
  { label: "Disqualified Leads", value: "disqualified leads" },
  { label: "Hot Leads", value: "hot leads" },
  { label: "Nurture Leads", value: "nurture leads" },
  { label: "Warm Leads", value: "warm leads" },
];



export const serviceTypeOptions = [
  { label: "Daily", value: "daily" },
  { label: "Weekly", value: "weekly" },
  { label: "Monthly", value: "monthly" },
  { label: "Yearly", value: "yearly" },
  { label: "Abheeshta Shubhakaryamulu", value: "abheesta" },
  { label: "Balabhoga Nivedana", value: "balabhoga" },
  // { label: "Visista Sevalu", value: "visista" }

];



export const serviceTimeOptions = [
  { label: "Morning", value: "morning" },
  { label: "Evening", value: "evening" },
  { label: "Both", value: "both" },
];
export const dealStage = [
  { label: "Cold Call", value: "cold call" },
  { label: "Closed", value: "closed" },
  { label: "Discussions", value: "discussions" },
  { label: "Proposal Sent", value: "proposal sent" },
  { label: "Prospecting", value: "prospecting" },
  { label: "Negotiation", value: "negotiation" },
];

export const ORDER_TYPE_OPTIONS = [
  { label: "Purchase", value: "purchase" },
  { label: "Sale", value: "sale" },
];

export const PAYMENT_TERMS_OPTIONS = [
  { value: "30 days", label: "Next 30 Days" },
  { value: "advance payment", label: "Advance Payment" },
  { value: "payment on delivery", label: "Payment on Delivery" },
];

export const ORDER_STATUS_OPTIONS = [
  { label: "New", value: "new" },
  { label: "Work in Progress", value: "work_in_progress" },
  { label: "Waiting for Raw Material", value: "waiting_for_raw_material" },
  { label: "Completed", value: "completed" },
];

export const SHIPMENT_DETAILS_OPTIONS = [
  { label: "Processing", value: "processing" },
  { label: "Shipped", value: "shipped" },
  { label: "In Transit", value: "intransit" },
  { label: "Delivered", value: "delivered" },
];

export const ITEM_ID_OPTIONS = [
  { label: "Item 1", value: "item1" },
  { label: "Item 2", value: "item2" },
];

export const RATING_OPTIONS = [
  { label: "1 - Poor", value: 1 },
  { label: "2 - Fair", value: 2 },
  { label: "3 - Good", value: 3 },
  { label: "4 - Very Good", value: 4 },
  { label: "5 - Excellent", value: 5 },
];

export const materialType = [{ label: "Type1", value: "Type1" }];

export const procurementType = [{ label: "Type1", value: "Type1" }];

export const MRPType = [{ label: "Type1", value: "Type1" }];

export const industry = [
  { label: "Type1", value: "Type1" },
  { label: "Other", value: "other" },
];

export const contactType = [
  { label: "Client", value: "Client" },
  { label: "Supplier", value: "Supplier" },
  { label: "Contractor", value: "Contractor" },
  { label: "Customer", value: "Customer" },
];

export const CONTRACT_TERMS_OPTIONS = [{ label: "1", value: "New" }];
export const PRODUCT_OPTIONS = [
  { label: "Product A", value: "product_a" },
  { label: "Product B", value: "product_b" },
];

export const MetricTypesData = [
  { label: "Revenue", value: "Revenue" },
  { label: "Deals Closed", value: "Deals Closed" },
  { label: "Leads Generated ", value: "Leads Generated" },
];

export const StatusTypes = [
  { label: "Draft", value: "Draft" },
  { label: "Posted", value: "Posted" },
  { label: "Reversed", value: "Reversed" },
];

export const matchStatusOptions = [
  { label: "Created", value: "Created" },
  { label: "UnMatched", value: "UnMatched" },
  { label: "Matched", value: "Matched" },
];
export const TypeOptions = [
  { label: "Debit", value: "Debit" },
  { label: "Credit", value: "Credit" },
];

export const contactTypes = [
  {
    label: "All",
    value: "All",
  },
  {
    label: "Customer",
    value: "Customer",
  },
  {
    label: "Supplier",
    value: "Supplier",
  },
];

export const ticketsstatusTypes = [
  {
    label: "Open",
    value: "Open",
  },
  {
    label: "Hold",
    value: "Hold",
  },
  {
    label: "InProgress",
    value: "InProgress",
  },
  {
    label: "Resolved",
    value: "Resolved",
  },
];

export const emailScreenNames = [
  {
    label: "Book Demo",
    value: "bookDemo",
  },
  {
    label: "Invoice",
    value: "viewInvoice",
  },
  {
    label: "Birthday",
    value: "Birthday",
  },
  {
    label: "process",
    value: "process",
  },
  {
    label: "WorkAnniversary",
    value: "WorkAnniversary",
  },
  {
    label: "claim",
    value: "claim",
  },
  {
    label: "viewJob",
    value: "viewJob",
  },
  {
    label: "CRM",
    value: "CRM",
  },
  {
    label: "Placement",
    value: "Placement",
  },
  {
    label: "InterviewSchedule",
    value: "InterviewSchedule",
  },
];

export const paymentTypes = [
  {
    label: "CASH",
    value: "CASH",
  },
  {
    label: "UPI",
    value: "UPI",
  },
  {
    label: "BANK",
    value: "BANK",
  },
  {
    label: "ONLINE",
    value: "ONLINE",
  },
];

export const groupBYTypes = [
  {
    label: "ALL",
    value: "All",
  },
  {
    label: "ANNA PRASADA SEVA (THURSDAY ONLY)",
    value: "ANNA PRASADA SEVA(THURSDAY ONLY)",
  },
  {
    label: "CASH",
    value: "CASH",
  },
  {
    label: "UPI",
    value: "UPI",
  },
];

export const reportTOTypes = [
  {
    label: "SEVA",
    value: "SEVA",
  },
  {
    label: "DONATIONS",
    value: "DONATION",
  },
];


export const DevoteeNameTypes = [
  {
    label: "S/O",
    value: "S/O",
  },
  {
    label: "W/O",
    value: "W/O",
  },
  {
    label: "D/O",
    value: "D/O",
  },
];


export const dayOptions = [
  { label: "Monday", value: "monday" },
  { label: "Tuesday", value: "tuesday" },
  { label: "Wednesday", value: "wednesday" },
  { label: "Thursday", value: "thursday" },
  { label: "Friday", value: "friday" },
  { label: "Saturday", value: "saturday" },
  { label: "Sunday", value: "sunday" },
];

export const specialPoojaOptions = [
  { label: "Namakaranam", value: "namakaranam" },
  { label: "Annaprasana", value: "annaprasana" },
  { label: "Aksharabhyasam", value: "aksharabhyasam" },
  { label: "Mandiram", value: "mandiram" },
  { label: "Two Wheeler Pooja", value: "Two Wheeler Pooja" },
  { label: "Four Wheeler Pooja", value: "Four Wheeler Pooja" },
  { label: "Annaprasadam - 1", value: "Annaprasadam - 1" },
  { label: "Annaprasadam - 2", value: "Annaprasadam - 2" },
  { label: "Saswatha Alankara Seva", value: "Saswatha Alankara Seva" },
  { label: "Ashtottara Shatanamavali Seva", value: "Ashtottara Shatanamavali Seva" },
];

export const servicesTypeOptions = [
  // { label: "VISISTA SEVALU", value: "visista sevas" },
  { label: "VISESHA SEVALU", value: "visista sevas" },
  { label: "UTSAVA SEVALU", value: "utsava sevas" }


]


export const sevasOptions = [
  { label: "Annaprasadam-1", value: "Annaprasadam-1" },
  { label: "Annaprasadam-2", value: "Annaprasadam-2" },
  { label: "Shashwatha AlankaraSeva", value: "ShashwathaAlankaraSeva" },
  { label: "AshtottaraSatanamavaliSeva", value: "AshtottaraSatanamavaliSeva" },
];